import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Topbarglobal() {
  const { mobile } = useSelector((state) => state.mobile);
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [pageTitle, setPageTitle] = useState("");

  // Update page title based on current route
  useEffect(() => {
    if (pathname.includes("/sensors/lookup")) {
      setPageTitle(t("sensor_lookup"));
    } else if (pathname.includes("/sensors/list") || pathname.includes("/sensors")) {
      setPageTitle(t("sensor_list"));
    } else if (pathname.includes("settings")) {
      setPageTitle(t("settings"));
    } else if (pathname.includes("dashboard")) {
      setPageTitle(t("dashboard.title"));
    } else if (pathname.includes("inventory")) {
      setPageTitle(t("inventory_title"));
    } else if (pathname.includes("project")) {
      setPageTitle(t("projects"));
    } else if (pathname.includes("trees")) {
      setPageTitle(t("trees"));
    } else {
      setPageTitle("");
    }
  }, [pathname, t]);

  return (
    <div className="header__end__nav-list">
      {!mobile && pageTitle && <h5 className="text-white mb-0 text-uppercase">{pageTitle}</h5>}
    </div>
  );
}
